var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgChangepassword = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "CurrentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378 1571 c-197 -63 -328 -241 -328 -446 0 -163 87 -316 228 -403 138 -84 345 -81 485 8 103 65 186 182 209 294 l11 56 353 0 354 0 0 -103 c0 -108 7 -127 45 -127 38 0 45 19 45 127 l0 103 95 0 95 0 0 -149 c0 -123 3 -152 16 -165 18 -19 28 -20 55 -6 18 10 19 23 19 165 l0 155 58 0 c32 0 63 5 70 12 15 15 15 51 0 66 -9 9 -158 12 -608 12 l-597 0 -13 58 c-35 160 -158 293 -317 342 -83 25 -197 26 -275 1z m249 -87 c199 -68 306 -274 244 -473 -67 -216 -318 -324 -518 -223 -71 36 -144 107 -174 169 -48 99 -48 231 0 333 40 85 143 171 241 201 45 13 158 10 207 -7z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChangepassword, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/changepassword.a87b6184.svg";
export { ForwardRef as ReactComponent };